export const dataUrlToFile = async (dataUrl: string, filename: string) => {
  const res = await fetch(dataUrl)
  const buf = await res.arrayBuffer()
  const mimeType = dataUrl.match(/(:)([a-z/]+)(;)/)![2]
  const extension = mimeType.split('/')[1]
  return new File([buf], filename + '.' + extension, { type: mimeType })
}
